import { styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';

export const Wrapper = styled('div')(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    minHeight: '100vh',
    height: 'auto',
    width: '100%',
    padding: '2rem',
    gap: '1.5rem',
    backgroundColor: palette.background.general,

    [theme.breakpoints.down('tablet')]: {
      padding: 0,
    },
  };
});

export const LeftBlock = styled('div')(({ theme }: { theme: Theme }) => {
  return {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '32px 32px 0 32px',
    alignItems: 'center',
    borderRadius: '1.5rem',
    backgroundColor: palette.background.branded_purple,

    [theme.breakpoints.down('desktop')]: {
      display: 'none',
    },
  };
});

export const LeftBlockHeader = styled('div')(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
  };
});

export const LeftBlockTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.white,
    fontWeight: 700,
    fontSize: '48px',
    lineHeight: '62px',
    margin: '16px 0 24px 0',
  };
}) as typeof Typography;

export const RightBlock = styled('div')(({ theme }: { theme: Theme }) => {
  return {
    position: 'relative',
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '1.5rem',
    borderRadius: '1.5rem',
    backgroundColor: palette.background.clear_white,

    '> form': {
      width: '100%',
    },

    [theme.breakpoints.down('desktop')]: {
      width: '100%',
    },

    [theme.breakpoints.down('tablet')]: {
      position: 'inherit',
      padding: '1rem',
      borderRadius: 0,
    },
  };
});

export const StepLabelText = styled(StepLabel)(({ theme }: { theme: Theme }) => {
  return {
    padding: 0,

    '.MuiStepLabel-iconContainer': {
      paddingRight: '10px',

      '.MuiSvgIcon-root': {
        width: '32px',
        height: '32px',
        color: 'transparent',
        border: '1px solid #D8DBE8',
        borderRadius: '50%',
        opacity: '0.5',

        '.MuiStepIcon-text': {
          fontWeight: 700,
          fontSize: '14px',
          lineHeight: '19px',
        },

        '&.Mui-active': {
          color: '#85C553',
          border: 'none',
          opacity: '1',
          letterSpacing: '1px',
          '.MuiStepIcon-text': {},
        },

        '&.Mui-completed': {
          color: '#85C553',
          border: 'none',
          opacity: '1',
          letterSpacing: '1px',
          backgroundColor: '#fff',
        },
      },
    },

    '.MuiStepLabel-labelContainer': {
      '.MuiStepLabel-label': {
        color: palette.white,
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '21px',
        opacity: 0.5,

        '&.Mui-active': {
          opacity: 1,
        },

        '&.Mui-completed': {
          opacity: 1,
        },
      },
    },
  };
});

export const CustomStepper = styled(Stepper)(({ theme }: { theme: Theme }) => {
  return {
    '.MuiStepConnector-root': {
      marginLeft: '15px!important',

      '.MuiStepConnector-line': {
        borderLeftWidth: '3px',
        borderColor: '#784FA4',
      },

      '&.Mui-disabled': {
        marginLeft: '15px!important',
      },
    },
  };
});
